export const aboutMeText = {
  JP: {
    textLines: [
      'オーストラリアでワーホリ中、撮影をメインにしたツアーを作り、世界中の方を撮影してきました。',
      'その経験を活かし、このツアーではただ絶景へ案内するだけでなく、写真や映像として美しく残すことまで大切にしています。',
      'ロケーション選び、光の入り方、撮影の角度、自然な雰囲気づくりまでこだわり、宮古島での思い出を一生残したくなる特別な体験としてお届けします。',
    ],
    hobby: '趣味: 旅、サーフィン🏄、スノーボード🏂、カメラ📸',
  },

  EN: {
    textLines: [
      'While on a working holiday in Australia, I created photo-focused tours and captured travelers from around the world.',
      'Using that experience, this tour is not just about taking you to beautiful places, but also about capturing those moments beautifully through photos and videos.',
      'From choosing the right location to finding the best light, angles, and natural atmosphere, I care about every detail to create a special Miyakoisland experience you will want to remember forever.',
    ],
    hobby: 'Hobbies: Travel, surfing🏄, snowboarding🏂, camera📸',
  },

  中文: {
    textLines: [
      '在澳大利亚打工度假期间，我曾创立以拍摄为主的旅行体验，并为来自世界各地的客人拍摄照片和视频。',
      '基于这段经历，这个行程不只是带您前往绝美景点，也重视将旅途中的瞬间用照片和影片美好地记录下来。',
      '从地点选择、光线、拍摄角度到自然氛围的营造，我都会用心安排，为您带来值得一生珍藏的宫古岛特别体验。',
    ],
    hobby: '爱好: 旅行、冲浪🏄、单板滑雪🏂、摄影📸',
  },

  한국어: {
    textLines: [
      '호주 워킹홀리데이 중 촬영을 중심으로 한 투어를 만들고, 전 세계에서 온 여행자들을 촬영해 왔습니다.',
      '그 경험을 바탕으로 이 투어에서는 단순히 아름다운 장소로 안내하는 것뿐만 아니라, 사진과 영상으로 아름답게 남기는 것까지 중요하게 생각합니다.',
      '장소 선택, 빛의 방향, 촬영 각도, 자연스러운 분위기까지 세심하게 신경 써서 미야코지마의 추억을 평생 간직하고 싶어지는 특별한 경험으로 전해드립니다.',
    ],
    hobby: '취미: 여행, 서핑🏄, 스노보드🏂, 카메라📸',
  },
};
